<input
  [(ngModel)]="checked"
  (change)="handleChange($event)"
  [disabled]="disabled()"
  type="checkbox"
  checked="checked"
  class="toggle toggle-primary" />
